import {
    resetCharmSuggestionsHighlightedIndex,
    setCharmSuggestionsHighlightedIndex,
} from 'owa-calendar-compose-form-actions';
import { mutator } from 'satcheljs';
import { getComposeViewState } from 'owa-calendar-compose-store-manager';

/**
 * Resets the value of the charm suggestions highlighted index
 */
mutator(resetCharmSuggestionsHighlightedIndex, actionMessage => {
    const composeViewState = getComposeViewState(actionMessage.formId);
    if (composeViewState?.charmSuggestionsViewState) {
        composeViewState.charmSuggestionsViewState.highlightedIndex = 0;
    }
});

/**
 * Updates the value of the highlighted index
 */
mutator(setCharmSuggestionsHighlightedIndex, actionMessage => {
    const { isIncrement, formId } = actionMessage;

    const charmSuggestionsViewState = getComposeViewState(formId).charmSuggestionsViewState;

    // We only want to set the index if the suggestions are being shown
    if (charmSuggestionsViewState.shouldShowSuggestions) {
        let newIndex;
        if (isIncrement) {
            newIndex = charmSuggestionsViewState.highlightedIndex + 1;
            // If the index is past the length of the array it resets to the first element
            if (newIndex >= charmSuggestionsViewState.suggestions.length) {
                newIndex = 0;
            }
        } else {
            newIndex = charmSuggestionsViewState.highlightedIndex - 1;
            // If the index is negative, it resets to the last element
            if (newIndex < 0) {
                newIndex = charmSuggestionsViewState.suggestions.length - 1;
            }
        }
        charmSuggestionsViewState.highlightedIndex = newIndex;
    }
});
